/**
 * Toast component.
 */
import Container from '@components/atoms/container/toastContainer';
import Text from '@components/atoms/text/toastText';
import { DELAY } from '@shared/types/constants/animations';
import { useEffect, useState } from 'react';

/**
 * Floating message bubble that fades in on mount, stays visible for
 * `duration` ms, then fades out.
 */
export default function Toast({
  message,
  duration = DELAY.TOAST_AUTO_CLOSE,
}: {
  message: string;
  duration?: number;
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Container visible={visible}>
      <Text>{message}</Text>
    </Container>
  );
}
